<template>
  <div class="callback">
  </div>
</template>

<script>
import { login } from '../../api/authorize'
import store from '../../store/index'
import {router} from '../../router'
import { Toast,Dialog } from 'vant';
import Vue from 'vue'

Vue.use(Dialog)

export default {
  components: {
    Toast,
    Dialog
  },
  data() {
    return {
      code:null,
      data:null
    };
  },
  async mounted(){
    var code = '';

    if('development' == process.env.NODE_ENV || this.$isDebug){
      code = '123';
      this.code = '123';
    }
    else{
     this.code = (new URL(window.location.href)).search.split('&')[0].split('=')[1];
     code = this.code;
    }
    

    Toast.loading({
      message: '授权认证中...',
      forbidClick: true,
      duration:0
    });


    if(code){
      let data = await login(code);

      Toast.clear();
      if(data.code == 200){
        store.commit('authorize/SET_TOKEN', data.data.token)
        store.commit('authorize/SET_USER', data.data.user)
        store.commit('authorize/SET_USERAVATAR', data.data.userAvatar)
        store.commit('authorize/SET_COMPANYNAME', data.data.companyName)

        router.push('/wechatLogin');
        return;
      }
      else{
        Dialog.alert({
          message: data.message,
        });
      }

      this.data = data;
    }
    else{
      console.error("获取code失败！");
    }
  },
  methods: {
  }
};
</script>
